import { Context } from 'components/hoc/Store';
import React, { useContext } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';

interface IPrivateRoute extends RouteProps {}
// Privatni cesta pro kontrolu prihlaseni (token)
const PrivateRoute: React.FC<IPrivateRoute> = ({ component, ...rest }) => {
    const { token } = useContext(Context);
    return (
        <Route
            exact={true}
            {...rest}
            render={() => (token ? <Route component={component} /> : <Redirect to={'/nezarazeny-ucet/bankid'} />)}
        />
    );
};

export default PrivateRoute;
